<template>
  <div class="my_donations">
    <div class="container">
      <div class="row">
        <div class="col-md-2">
          <sidebar />
        </div>
        <div class="col-md-10 my_donations__table--wraper">
          <div class="my_donations__table">
            <div class="my_donations__table--title mb-5">BAĞIŞLARIM</div>
            <vuetable
              v-show="!isLoading"
              class="table"
              :api-url="url"
              :http-fetch="getData"
              pagination-path
              :per-page="999"
              @vuetable:loaded="onLoaded"
              @vuetable:loading="onLoading"
              :noDataTemplate="'Kayit bulunamadi'"
              :fields="columns"
            >
              <template
                slot="receipt_date"
                scope="props"
              >{{getNiceDate(props.rowData.receipt_date)}}</template>
              <template
                slot="total"
                scope="props"
              >{{parseFloat(props.rowData.total).toLocaleString() + ' TL'}}</template>

              <template slot="detail__button" scope="props">
                <router-link :to="'/bagislarim/'+props.rowData.id" class="btn btn-info">Detay</router-link>
              </template>
            </vuetable>

            <Loader v-show="isLoading" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vuetable from 'vuetable-2'
import { mapState } from 'vuex'
import Sidebar from '@/components/Sidebar.vue'

export default {
  data() {
    return {
      isLoading: false,
      columns: [
        {
          name: 'id',
          title: 'Bağış No'
        },
        {
          name: '__slot:receipt_date',
          title: 'Tarih'
        },
        {
          name: 'details_count',
          title: 'Bağış Adeti'
        },
        {
          name: '__slot:total',
          title: 'Toplam'
        },
        {
          name: '__slot:detail__button',
          title: 'Bağış Detayı'
        }
      ]
    }
  },
  computed: {
    ...mapState(['user'])
  },
  components: {
    Sidebar,
    Vuetable
  },
  methods: {
    getNiceDate(date) {
      const year = date.substr(0, 4)
      const month = date.substring(
        date.indexOf('-') + 1,
        date.lastIndexOf('-')
      )
      const day = date.substring(date.lastIndexOf('-') + 1, date.length)

      return `${day}-${month}-${year}`
    },
    getData(apiUrl, httpOptions) {
      return this.$http.get(apiUrl, httpOptions)
    },
    onLoading() {
      this.isLoading = true
    },
    onLoaded() {
      this.isLoading = false
    }
  },
  created() {
    this.url = `${this.$http.defaults.baseURL}v2/receipt?donator_user_id=${this.user.data.id}`
  }
}
</script>
